exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".closable-overlay__info-overlay__2ur6S{position:absolute;top:0;left:0;right:0;bottom:0;z-index:150;transition:opacity .2s;line-height:normal}.closable-overlay__close__1ltA7{position:absolute;z-index:180;top:17px;right:17px;overflow:hidden;color:hsla(0,0%,100%,.7);font-size:20px;cursor:pointer}.closable-overlay__close-fullscreen__3hHWY{font-size:41px}.closable-overlay__content__W5Act{position:absolute;top:0;left:0;right:0;bottom:0;z-index:170;color:#fff;background-color:rgba(0,0,0,.85)}.closable-overlay__content__W5Act.closable-overlay__half__TYtRF{left:50%}.closable-overlay__content__W5Act.closable-overlay__full-screen__1pFIl{left:calc(100% - 630px)}@media (max-width:639px){.closable-overlay__info-overlay__2ur6S{width:100%;max-width:480px;left:auto}.closable-overlay__info-overlay__2ur6S.closable-overlay__full-width__3ijtd{max-width:none}.closable-overlay__content__W5Act.closable-overlay__full-screen__1pFIl,.closable-overlay__content__W5Act.closable-overlay__half__TYtRF{left:0}}", ""]);

// exports
exports.locals = {
	"info-overlay": "closable-overlay__info-overlay__2ur6S",
	"infoOverlay": "closable-overlay__info-overlay__2ur6S",
	"close": "closable-overlay__close__1ltA7",
	"close-fullscreen": "closable-overlay__close-fullscreen__3hHWY",
	"closeFullscreen": "closable-overlay__close-fullscreen__3hHWY",
	"content": "closable-overlay__content__W5Act",
	"half": "closable-overlay__half__TYtRF",
	"full-screen": "closable-overlay__full-screen__1pFIl",
	"fullScreen": "closable-overlay__full-screen__1pFIl",
	"full-width": "closable-overlay__full-width__3ijtd",
	"fullWidth": "closable-overlay__full-width__3ijtd"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/components/closable-overlay/closable-overlay.styl
// module id = 1638
// module chunks = 1 2 3